const pageFrLang = {
  // country page
  countryPage_countries: 'Pays',
  countryPage_countryName: 'Nom du pays',
  countryPage_noOfGsmOperators: `Nb d'opérateurs GSM`,
  countryPage_nationalNumLength: 'Longueur du numéro national',
  countryPage_internationalCountryCode: 'Indicatif du pays',
  countryPage_alphaCode: 'Code alpha',
  countryPage_timeZoneId: 'Fuseau horaire',
  countryPage_CreateCountry: 'Créer un pays',
  countryPage_UpdateCountry: 'Mettre à jour le pays',
  // update profile
  updateProfile_title: 'Mettre à jour le profil',
  updateProfile_FirstName: 'Prénom',
  updateProfile_LastName: 'Nom de famille',
  updateProfile_Email: 'E-mail',
  updateProfile_Phone: 'Téléphoner',

  // update password
  updatePassword_Title: 'Modifier le mot de passe',
  updatePassword_ChangePasswordSuccess: 'Changement de mot de passe réussi',
  updatePassword_CurrentPassword: 'Mot de passe actuel',
  updatePassword_NewPassword: 'Nouveau mot de passe',
  updatePassword_ConfirmPassword: 'Confirmer le mot de passe',
  updatePassword_PasswordNotMatch: 'Le mot de passe saisi ne correspond pas',
  // email template
  emailTemplate_Title: `Modèles d'e-mail`,
  emailTemplate_CreateEmailTemplate: `Créer un modèle d'e-mail`,
  emailTemplate_UpdateEmailTemplate: `Mettre à jour le modèle d'e-mail`,
  emailTemplate_NameEmailTemplate: `Nom du modèle d'e-mail`,
  emailTemplate_EmailTemplate_ToEmail: 'Pour envoyer un e-mail (autoriser plusieurs e-mails, séparer par)',
  emailTemplate_EmailTemplate_CcEmail: 'E-mail Cc (autoriser plusieurs e-mails, séparés par)',
  emailTemplate_EmailTemplate_BccEmail: 'E-mail en Cci (autoriser plusieurs e-mails, séparés par)',
  emailTemplate_EmailTemplate_Subject: 'Objet',
  emailTemplate_Subject: 'Objet',
  emailTemplate_Body: 'Corps',
  emailTemplate_NameEmailTemplatePlaceholder: `Modèle d'e-mail choisi`,
  emailTemplate_Active: 'Actif',
  emailTemplate_Attachment: 'Pièce jointe',
  emailTemplate_CultureCode: 'Code culturel',
  // regions
  regionPage_title: 'Régions',
  regionPage_Name: 'Nom',
  regionPage_Country: 'Pays',
  regionPage_CreateRegion: 'Créer une région',
  regionPage_UpdateRegion: 'Créer une région',
  // cities
  cityPage_Title: 'Villes',
  cityPage_Name: 'Nom de la ville',
  cityPage_Code: 'Code de la ville',
  cityPage_Country: 'Pays',
  cityPage_Region: 'Région',
  regionPage_CreateCity: 'Créer une ville',
  regionPage_UpdateCity: 'Mise à jour de la ville',
  // forgot password
  forgotPasswordPage_TitleForgotPassword: 'Mot de passe oublié',
  forgotPasswordPage_EmailAddress: 'Veuillez saisir votre e-mail',
  forgotPasswordPage_Submit: 'Soumettre',
  forgotPasswordPage_BackToLoginPage: 'Retour à la page de connexion',
  forgotPasswordPage_ForgotPasswordSuccess: `Nous avons envoyé un e-mail à <b>{{email}}</b> pour demander une réinitialisation du mot de passe !
                                            <br/>Veuillez cliquer sur le lien dans les 30 minutes.
                                            <br/>Ou vous devrez demander un nouveau lien.
                                            <br/>Si vous ne voyez pas l'e-mail, vérifiez votre dossier spam. `,
  forgotPasswordPage_ForgotPassword_Hint: `Une URL permettant de réinitialiser votre mot de passe vous sera envoyée.
                                          <br />Veuillez saisir votre adresse électronique enregistrée et cliquer sur le bouton "Soumettre".`,

  //reset password
  resetPasswordPage_TitleResetPassword: 'Réinitialiser le mot de passe',
  resetPasswordPage_TitleHint: 'Veuillez définir un nouveau mot de passe',
  resetPasswordPage_ForgotPasswordSessionExpired: 'La session de mot de passe oublié a expiré',
  resetPasswordPage_ResetPasswordSuccess: 'Réinitialisation du mot de passe réussie',
  //confirm email
  confirmEmailPage_Title: "Confirmation de l'adresse e-mail",
  confirmEmailPage_Success: 'Votre adresse e-mail est confirmée. Vous pouvez vous connecter.',
  confirmEmailPage_Invalid: "Ce lien de confirmation n'est pas valide ou a expiré.",
  // select entity
  selectEntityPage_Title: 'Sélectionner une entité',
  selectEntityPage_Operations: 'Exploitation',
  selectEntityPage_Operations_SubTitle: 'Gérez votre exploitation',
  selectEntityPage_Configurations: 'Configuration',
  selectEntityPage_Configurations_SubTitle: 'Configurations',
  selectEntityPage_Monitoring: 'Surveillance',
  selectEntityPage_Monitoring_SubTitle: 'Surveillance du système',
  // admin users
  adminUsersPage_Title: 'Utilisateurs administrateurs',
  adminUsersPage_Username: `Nom d'utilisateur`,
  adminUsersPage_Email: 'E-mail',
  adminUsersPage_FullName: 'Nom complet',
  adminUsersPage_Phone: 'Téléphone',
  adminUsersPage_emailConfirmed: 'E-mail confirmé',
  adminUsersPage_LastLogin: 'Dernière connexion',
  adminUsersPage_IsBlackListed: 'Est sur la liste noire',
  adminUsersPage_SearchText: 'Nom, e-mail, téléphone...',
  adminUsersPage_Roles: 'Rôles',
  adminUsersPage_UserRemarks: `Remarques de l'utilisateur`,
  adminUsersPage_FirstName: 'Prénom',
  adminUsersPage_LastName: 'Nom de famille',
  adminUsersPage_CreateUser: 'Créer un utilisateur',
  adminUsersPage_UpdateUser: `Mettre à jour l'utilisateur`,
  adminUsersPage_ReportingManager: 'Gestionnaire de rapports',
  adminUsersPage_AllUser: 'Tous les utilisateurs',
  adminUsersPage_ExportUsers: 'Exporter les utilisateurs administrateurs',
  // access control page
  accessControlPage_Title: `Contrôle d'accès`,
  accessControlPage_Password: 'Mot de passe',
  accessControlPage_Requirement: 'Exigence',
  accessControlPage_PasswordLength: 'Longueur minimale du mot de passe',
  accessControlPage_NoOfUpperCase: 'Nombre de majuscules',
  accessControlPage_NoOfLowerCase: 'Nombre de minuscules',
  accessControlPage_NoOfSpecialCharacters: 'Nombre de caractères spéciaux',
  accessControlPage_NoOfNumericCharacters: 'Nombre de caractères numériques',
  accessControlPage_PasswordExpirationDays: 'Expiration du mot de passe (jours)',
  accessControlPage_AllowNameCharacters: 'Autoriser le mot de passe à contenir le nom ou le prénom et leurs ordres inverses',
  accessControlPage_PreventPasswordReuse: 'Empêcher la réutilisation du mot de passe',
  accessControlPage_UpdateSucessMessage: 'Mise à jour réussie',
  accessControlPage_2faSubtitle: 'Authentification à deux facteurs',
  accessControlPage_2faGlobalUser: `Activer l'authentification à deux facteurs pour les utilisateurs globaux`,
  accessControlPage_2faCompanyUser: `Activer l'authentification à deux facteurs pour les utilisateurs de l'entreprise`,
  // login page
  loginPage_2FaAuthentication: 'Authentification à deux facteurs',
  loginPage_YourVerifycationCode: 'Votre code de vérification',
  loginPage_ReSendCode: 'Renvoyer le code de vérification',
  loginPage_Verify: 'Vérifier',
  loginPage_ChangeProvider: 'Sélectionner un autre fournisseur',
  loginPage_PleaseSelectProvider: 'Veuillez sélectionner un fournisseur pour recevoir un code',
  loginPage_Email: 'E-mail',
  loginPage_EmailSubTitle: ` Un code de vérification sera envoyé à l'e-mail <b>{{email}}</b>`,
  loginPage_PhoneNumber: 'Numéro de téléphone',
  loginPage_PhoneSubTitle: 'Un code de vérification sera envoyé à votre numéro de téléphone <b>{{phone}}</b>',
  loginPage_Send: 'Envoyer',
  loginPage_AuthenticatorTitle: "Application d'authentification",
  loginPage_AuthenticatorRequired:
    "Votre compte exige une application d'authentification (Google Authenticator, Microsoft Authenticator…). Configurez-la maintenant : les codes par e-mail et SMS restent disponibles en secours.",
  loginPage_AuthenticatorStart: "Configurer l'application d'authentification",
  loginPage_AuthenticatorScan: "Scannez ce QR code avec votre application d'authentification, puis saisissez le code à 6 chiffres qu'elle affiche.",
  loginPage_AuthenticatorManualKey: 'Ou saisissez cette clé à la main :',
  loginPage_AuthenticatorCodeHint: "Saisissez le code à 6 chiffres affiché par votre application d'authentification.",
  loginPage_RecoveryCodeHint: "Saisissez l'un de vos codes de secours. Chaque code ne sert qu'une fois.",
  loginPage_RecoveryCodesHint:
    'Conservez ces codes de secours en lieu sûr : ils permettent de vous connecter si vous perdez votre téléphone. Ils ne seront plus affichés.',
  loginPage_UseAuthenticator: "Utiliser l'application d'authentification",
  loginPage_UseRecoveryCode: 'Utiliser un code de secours',
  loginPage_Continue: 'Continuer',
  loginPage_Later: 'Plus tard',
  // partner
  partnerPage_Title: 'Partenaires',
  partnerPage_MNOS: 'MNOS',
  partnerPage_Bank: 'Banque',
  partnerPage_Utility: 'Utilitaire',
  partnerPage_Name: 'Nom',
  partnerPage_TechnicalPhoneNumber: 'Numéro de téléphone technique',
  partnerPage_TechnicalSupportEmail: `E-mail d'assistance technique`,
  partnerPage_ConnectivityDetails: 'Détails de la connectivité',
  partnerPage_CreatePartner: 'Créer un partenaire',
  partnerPage_UpdatePartner: 'Mettre à jour le partenaire',
  partnerPage_ContactEmail: 'E-mail de contact',
  partnerPage_MonetaryZone: 'Zone monétaire',
  partnerPage_SearchText: 'Nom du partenaire, numéro de téléphone...',
  partnerPage_PartnerAccount: 'Compte partenaire utilitaire',
  partnerPage_CreateUtilityPartner: 'Créer un compte partenaire utilitaire',
  partnerPage_UpdateUtilityPartner: 'Mettre à jour le compte du partenaire utilitaire',
  partnerPage_UtilityConnectivityDetails: 'Détails de la connectivité du partenaire utilitaire',
  partnerPage_UpdateUtilityConnectivityDetails: 'Mettre à jour les détails de connectivité du partenaire utilitaire',
  partnerPage_CreateUtilityConnectivityDetails: 'Créer les détails de connectivité du partenaire utilitaire',
  partnerPage_Bank_OperatorName: `Nom de la banque/de l'opérateur`,
  partnerPage_AccountType: 'Type de compte',
  partnerPage_AccountOwner: 'Propriétaire du compte',
  partnerPage_AccountNumber: 'Numéro de compte',
  partnerPage_UtilityPartnerAccounts: 'Comptes partenaires utilitaires',
  partnerPage_CreateUtilityPartnerAccount: 'Créer un compte partenaire utilitaire',
  partnerPage_UpdateUtilityPartnerAccount: 'Mettre à jour le compte du partenaire utilitaire',
  passengerPage_ExportUtilityPartners: 'Exporter des partenaires utilitaires',
  passengerPage_ExportPaymentPartner: 'Exporter des partenaires de paiement',
  partnerPage_LogoImage: 'Logo',
  // company page
  companyPage_Title: 'Entreprises',
  companyPage_SearchText: `Nom de l'entreprise, numéro de téléphone...`,
  companyPage_CompanyName: 'Nom',
  companyPage_PlanName: 'Plan',
  companyPage_NoOfStations: 'Nb de stations',
  companyPage_CityRegionCountry: 'Ville, Région, Pays',
  companyPage_EmployeeNo: `N° d'employé`,
  companyPage_SMS_Email_NotificationAllow: 'Notification',
  companyPage_ExportCompanies: 'Entreprises exportatrices',
  companyPage_IsApproved: 'Est approuvé',
  companyPage_InActiveTicketSelling: 'Définir la vente de billets inactive',
  companyPage_ActiveTicketSelling: 'Définir la vente de billets actifs',
  // passenger page
  passengerPage_Title: 'Passagers',
  passengerPage__SearchText: 'E-mail, nom complet, numéro de téléphone...',
  passengerPage_IsTicketBookingAllowed: 'La réservation de billets est-elle autorisée',
  passengerPage_ExportPassengers: 'Exporter des passagers',
  // service page
  servicePages_Title: 'Services',
  servicePages_SearchText: 'Nom du service',
  servicePages_ServiceName: 'Nom du service',
  servicePages_ActivationDate: `Date d'activation`,
  servicePages_AvailableApps: 'Applications disponibles',
  servicePages_MasterServiceType: 'Lien vers le service maître',
  servicePages_FeePayingEntities: 'Entités payantes',
  servicePages_FeeSharingEntities: 'Entités de partage de frais',
  servicePages_IsPercentageBase: 'Est un pourcentage',
  servicePages_Customer: 'Client',
  servicePages_Rate: 'Taux',
  servicePages_Merchant: 'Marchand',
  servicePages_MonektoUsers: 'Utilisateurs Monekto',
  servicePages_TransportCompanies: 'Entreprises de transport',
  servicePages_Mtopo: 'Mtopo',
  servicePages_Operators: 'Opérateurs',
  servicePages_CreateService: 'Créer un service',
  servicePages_UpdateService: 'Service de mise à jour',
  // software Components page
  softwareComponentsPage_ComponentName: 'Nom du composant',
  softwareComponentsPage_ComponentType: 'Type de composant',
  softwareComponentsPage_Price: 'Prix',
  softwareComponentsPage_AvailableApps: 'Applications disponibles',
  softwareComponentsPage_Title: 'Composants logiciels',
  // plan page
  planPage_Title: 'Plans',
  planPage_SearchText: 'Nom du forfait...',
  planPage_PlanName: 'Nom du plan',
  planPage_NoOfRegister: 'N° de registre',
  planPage_TransactionLimit: 'Limite de transactions',
  planPage_Turnover: `Chiffre d'affaires`,
  planPage_MonthlyFee: 'Frais mensuels',
  planPage_PaymentTerm: 'Délai de paiement',
  planPage_PaymentMethodType: 'Mode de paiement',
  planPage_PlanType: 'Type de forfait',
  planPage_IsPopular: 'Est populaire',
  planPage_Components: 'Composants',
  planPage_AvailableApps: 'Applications disponibles',
  planPage_TransactionFee: 'Frais de transaction',
  planPage_Services: 'Services',
  planPage_CreatePlan: 'Créer un plan',
  planPage_UpdatePlan: 'Mettre à jour le plan',
  // Étape 5 (2026-11-02) : clés qui n'existaient qu'en anglais.
  countryPage_UpdateCountry_IsOperating: 'En service',
  selectEntityPage_PassengerAppConfigurations: 'App passagers',
  selectEntityPage_PassengerAppConfiguration_SubTitle: 'Configuration de l\'app passagers',
  loginPage_CodeHasSend2Email: 'Un code de vérification a été envoyé à l\'adresse <b>{{email}}</b>',
  loginPage_CodeHasSend2Phone: 'Un code de vérification a été envoyé à votre numéro <b>{{phone}}</b>',
  passengerDiscountPage_Title: 'Remises de l\'app passagers',
  passengerDiscountPage_PromoCode: 'Code promo',
  passengerDiscountPage_AutoApply: 'Application automatique',
  passengerDiscountPage_RefNo: 'Référence',
  passengerDiscountPage_ShortDescription: 'Description courte',
  passengerDiscountPage_MaxDiscountAmount: 'Remise maximale',
  passengerDiscountPage_ApplicationTarget: 'Cible',
  passengerDiscountPage_PromoPhotoUrl: 'Image promotionnelle',
  passengerDiscountPage_Company: 'Compagnie',
  passengerDiscountPage_SelectCompany: 'Choisir les compagnies',
  passengerDiscountPage_DiscountUsage: 'Utilisation de la remise',
  passengerDiscountPage_NoOfApplyTimes: 'Nombre d\'utilisations',
  passengerDiscountPage_DiscountUser: 'Bénéficiaires',
  passengerDiscountPage_NewUserAfterDate: 'Nouveaux utilisateurs après le',
  passengerDiscountPage_OldUserBeforeDate: 'Anciens utilisateurs avant le',
  passengerDiscountPage_SelectUsers: 'Choisir les utilisateurs',
  passengerBookingPage_Title: 'Réservations de l\'app passagers',
  passengerBookingPage_TotalAmount: 'Montant',
  passengerBookingPage_PayMode: 'Mode de paiement',
  passengerSettingPage_Title: 'Réglages de l\'app passagers',
  passengerBookingPage_ConfirmationBookingNotification: 'Notification de confirmation de réservation',
  sellOnTheGoReconciliation_PageTitle: 'Rapprochements des ventes en route',
  sellOnTheGoReconciliation_SelectDriverOrCoDriver: 'Choisir le chauffeur ou le convoyeur',
  sellOnTheGoReconciliation_TotalBookingAmount: 'Total des réservations',
  sellOnTheGoReconciliation_DeclaredAmount: 'Montant déclaré',
  sellOnTheGoReconciliation_ExpectedAmount: 'Montant attendu au tarif',
  sellOnTheGoReconciliation_AmountGap: 'Écart',
  passengerAppUser_Title: 'Utilisateurs Prisme',
  passengerAppUser_RegisterSource: 'Origine de l\'inscription',
  passengerAppUser_PhoneNumberConfirmed: 'Téléphone confirmé',
  passengerAppUser_PhoneNumber: 'Téléphone',
  passengerAppUser_IsActive: 'Actif',
  passengerAppUser_RegisterDate: 'Date d\'inscription',
  passengerAppUser_WalletBlocked: 'Portefeuille bloqué',
  passengerAppUser_ShowPassengerInfo: 'Voir le passager',
  passengerAppUser_BlockPassengerWalletConfirm: 'Changer l\'autorisation du portefeuille de cet utilisateur ?',
  passengerAppUser_BlockWallet: 'Bloquer le portefeuille',
  passengerAppUser_UnBlockWallet: 'Débloquer le portefeuille',
  passengerAppUser_EmailConfirmed: 'E-mail confirmé',
  passengerAppUser_UserFollowupsDetails: 'Suivi de l\'utilisateur',
  passengerAppUser_Comment: 'Commentaire',
  passengerAppUser_FollowUpDateTime: 'Date du suivi',
  passengerAppUser_NextFollowUpDateTime: 'Prochain suivi',
  passengerAppUser_FollowUpType: 'Type de suivi',
  passengerAppUser_CreateNew: 'Créer',
  passengerAppUser_Update: 'Modifier',
};

export default pageFrLang;
